import { useEffect, useState } from "react";
import {
  Banner,
  Button,
  Text,
  Card,
  LegacyStack,
  FormLayout,
  Layout,
  Link,
  Page,
  Select,
  LegacyCard,
  SkeletonBodyText,
  TextField,
  Popover,
  ActionList,
  InlineStack,
} from "@shopify/polaris";
import Axios from "./common/Axios";
import axios from "axios";
import { Element, scroller } from 'react-scroll';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import categoryJson0 from "../category-json/categories_0.json";
import { toast } from "react-toastify";
import useIsMobile from './useIsMobile';
export function Addprofile() {
  const location = useLocation();
  const sh_product_id = location.state?.ids || [];
  const multi_variation_check= location.state?.multi_variation_check || false;
  
const isMobile = useIsMobile();
  


  const domain = process.env.REACT_APP_BASE_URL;

  const savedData = localStorage.getItem("storeData");
  const localData = savedData ? JSON.parse(savedData) : null;
  const userData = localData;
  const navigate = useNavigate(); // Navigation hook
  const [profileName, setProfileName] = useState("");
  const [listingFormat, setListingFormat] = useState("");
  const [errors, setErrors] = useState({});
  const [showSkelton,setShowSkelton] = useState(false);
  const [selectedDuration, setSelectedDuration] = useState("");
  const [shippingProfiles, setShippingProfiles] = useState([
    { label: "Please add Shipping policy to your eBay account", value: "" },
  ]);
  const [paymentProfiles, setPaymentProfiles] = useState([
    { label: "Please add Payment policy to your eBay account", value: "" },
  ]);
  const [returnProfiles, setReturnProfiles] = useState([
    { label: "Please add Return policy to your eBay account", value: "" },
  ]);
  const [ebayProfile, setEbayProfile] = useState(false);
  const [noBusinessPolicies, setNoBusinessPolicies] = useState(false);
  const [categories, setCategories] = useState([]); // Full category data from API
  const [finalCategoryId, setFinalCategoryId] = useState(null); // Full category data from API
  const [selectedLevels, setSelectedLevels] = useState([]); // Selected categories
  const [categoryLevels, setCategoryLevels] = useState([]); // Stores options for each level
  const [categoryAvail, setCategoryAvail] = useState(false); // Stores options for each level
  const [popoverActive, setPopoverActive] = useState(null);
  const [selectedProfiles, setSelectedProfiles] = useState({
    Shipping: "",
    Payment: "",
    Return: "",
  });
  const [saveButtonDisable, setSaveButtonDisable] = useState(true);
  const [is_variantions, setIsVariantions] = useState(1);
  const [showBanner, setShowBanner] = useState(true);
  const [productTypeEnable, setProductTypeEnable] = useState(false);
  const [categoriesResponse, setCategoriesResponse] = useState();
  const [itemCondition, setItemCondition] = useState();
  const [selectedCondition, setSelectedCondition] = useState("");
  const [variationSupported, setVariationSupported] = useState(true);
  const [productType, setProductType] = useState([]);
  const [productType1, setProductType1] = useState();
  const [recommendedCheck, setRecommendedCheck] = useState(false);
  const [varifyError, setVerifyError] = useState([]);
  const [verifyErrorEnable, setVerifyErrorEnable] = useState(false);
  const [recommended, setRecommended] = useState([]);

  const [productTypeArray, setProductTypeArray] = useState([]);
  const [productTypeCheck, setProductTypeCheck] = useState(false);
  const [conditionOptions, setConditionOptions] = useState();

  const [ebay_category, setEbayCategory] = useState();
  const [ebay_category1, setEbayCategory1] = useState();
  const [itemConditionDate, setItemConditionData] = useState([]);
  const togglePopover = (index) => {
    setPopoverActive(popoverActive === index ? null : index);
  };
   const domainSite = {
        0: 'https://www.ebay.com',
        2: 'https://www.ebay.ca',
        3: 'https://www.ebay.co.uk',
        15: 'https://www.ebay.com.au',
        16: 'https://www.ebay.at',
        23: 'https://www.befr.ebay.be',
        71: 'https://www.ebay.fr',
        77: 'https://www.ebay.de',
        100: 'https://www.ebay.com',
        101: 'https://www.ebay.it',
        123: 'https://www.benl.ebay.be',
        146: 'https://www.ebay.nl',
        186: 'https://www.ebay.es',
        193: 'https://www.ebay.ch',
        201: 'https://www.ebay.com.hk',
        205: 'https://www.ebay.ie',
        207: 'https://www.ebay.com.my',
        210: 'https://www.cafr.ebay.ca',
        211: 'https://www.ebay.ph',
        212: 'https://www.ebay.pl',
        216: 'https://www.ebay.com.sg'
      };
  const handleAction = async (action, index) => {
    setPopoverActive(null);

    if (action === "Create") {
            const siteId= localData.user.eb_key[0].siteid;
            const ebayUrl = domainSite[siteId];

            const urls = [
                `${ebayUrl}/bp/ship/create`,
                `${ebayUrl}/bp/payment/create`,
                `${ebayUrl}/bp/rtn/create`
              ];
      window.open(urls[index], "_blank");
    } else if (action === "Refresh") {
      try {
        const ebayProfilesResponse = await Axios.get(
          "/profile/refreshShoppingProfile",
        );
        const ebayProfilesData = ebayProfilesResponse.data;

        if (index === 0 && ebayProfilesData.shipping_policies?.length) {
          setShippingProfiles([
            { label: "Select Shipping policy", value: "" },
            ...ebayProfilesData.shipping_policies.map((policy) => ({
              label: policy.ProfileName,
              value: policy.ID.toString(),
              key: `shipping-${policy.ID}`,
            })),
          ]);
        } else if (index === 1 && ebayProfilesData.payment_policies?.length) {
          setPaymentProfiles([
            { label: "Select Payment policy", value: "" },
            ...ebayProfilesData.payment_policies.map((policy) => ({
              label: policy.ProfileName,
              value: policy.ID.toString(),
              key: `payment-${policy.ID}`,
            })),
          ]);
        } else if (index === 2 && ebayProfilesData.return_policies?.length) {
          setReturnProfiles([
            { label: "Select Return policy", value: "" },
            ...ebayProfilesData.return_policies.map((policy) => ({
              label: policy.ProfileName,
              value: policy.ID.toString(),
              key: `return-${policy.ID}`,
            })),
          ]);
        }
      } catch (error) {
        console.error(
          `Error fetching ${["Shipping", "Payment", "Return"][index]} profiles:`,
          error,
        );
      }
    }
  };
  const handleProfileChange = (profileType, value) => {
    setSelectedProfiles((prev) => ({ ...prev, [profileType]: value }));
  };
  const handleChangeCondition = (value) => {
    const selected = conditionOptions.find((opt) => opt.value === value);
    setSelectedCondition(selected);
  };
  const listingOptions = [
    { label: "Select an option", value: "" },
    { label: "Fixed Price", value: "fixed-price" },
    { label: "Auction", value: "auction" },
  ];

  const productTypeOptions = [
    { label: "SKU", value: "sku" },
    { label: "Barcode", value: "barcode" },
  ];
  const recommendedOptions = [
    { label: "Set Ebay Recommended", value: "recommenedValue" },
    { label: "Set Custom Value", value: "customValue" },
    { label: "Set Shopify Attribute", value: "shopifyValue" },
  ];
  const [selectedMethod, setSelectedMethod] = useState({});
  const [selectedValue, setSelectedValue] = useState({});
  const idTypeOptions = [
    { label: "UPC", value: "UPC" },
    { label: "ISBN", value: "ISBN" },
    { label: "EAN", value: "EAN" },
    { label: "MPN", value: "MPN" },
  ];
  const fixedListingDuration = [
    { label: "Select an option", value: "" },
    { value: "GTC", label: "GTC" },
  ];
  const shopifyAttributeOptions = [
    { label: "Vendor", value: "vendor" },
    { label: "Handle", value: "handle" },
    { label: "Product Type", value: "product_type" },
    { label: "Sku", value: "sku" },
    { label: "Barcode", value: "barcode" },
    { label: "Color", value: "color" },
    { label: "Title", value: "title" },
  ];
  const [productTypeHeadOptions, setProductTypeHeadOptions] = useState([
        { label: "UPC", value: "UPC" },
        { label: "EAN", value: "EAN" },
        { label: "MPN", value: "MPN" },
        { label: "ISBN", value: "ISBN" },
    ]);


  const auctionListingDuration = [
    { label: "Select an option", value: "" },
    { value: "Days_3", label: "3 Days" },
    { value: "Days_5", label: "5 Days" },
    { value: "Days_7", label: "7 Days" },
    { value: "Days_10", label: "10 Days" },
  ];
  const handleListingFormatChange = (value) => {
    setListingFormat(value);
    setSelectedDuration(""); // Reset duration when listing format changes
  };
  const handleDurationChange = (value) => {
    setSelectedDuration(value);
  };

  const handleMethodChange = (key, method) => {
    setSelectedMethod((prev) => ({ ...prev, [key]: method }));

    if (method === "recommenedValue") {
      setSelectedValue((prev) => ({ ...prev, [key]: recommended[key][0] }));
    } else if (method === "shopifyValue") {
      setSelectedValue((prev) => ({
        ...prev,
        [key]: shopifyAttributeOptions[0].value,
      }));
    } else {
      setSelectedValue((prev) => ({ ...prev, [key]: "" }));
    }
  };

  const handleValueChange = (key, value) => {
    setSelectedValue((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const getFinalMappedValues = () => {
    const result = [];

    Object.keys(selectedValue).forEach((key) => {
      const method = selectedMethod[key];
      const value = selectedValue[key];

      if (!value) return; // skip empty

      if (method === "recommenedValue") {
        result.push({ [key]: { recommendation: value } });
      } else if (method === "customValue") {
        result.push({ [key]: { custom: value } });
      } else if (method === "shopifyValue") {
        result.push({ [key]: { shopify: value } });
      }
    });

    return result;
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [ebayProfilesResponse] = await Promise.all([
          Axios.get("/fetchEbayProfiles"),
        ]);
        const savedData = localStorage.getItem("storeData");
        const localData = savedData ? JSON.parse(savedData) : null;
            // try {
            //       const siteId= localData.user.eb_key[0].siteid;
            //   const response = await fetch(
            //        `https://cp2.infoshoreapps.com/api/public/category-json/categories_${siteId}.json`
            //     );

            //   if (!response.ok) {
            //     throw new Error("Network response was not ok");
            //   }

            //   const categoriesData = await response.json();
            //   // setCategories(data);
            //    setCategories(categoriesData);

            //   const topLevelCategories = Array.from(
            //     new Set(
            //       categoriesData.map(
            //         (item) => item.category_tree_name.split(" > ")[0],
            //       ),
            //     ),
            //   ).map((category) => ({ label: category, value: category }));

            //   setCategoryLevels([topLevelCategories]);
            //   setSelectedLevels([""]);
            //   setCategoryAvail(true);
            // } catch (error) {
            //   console.error("Error fetching the JSON:", error);
            // }

        // console.log(categoryJson0);

        // Handling categories data
        const categoriesData = categoryJson0;
        if (Array.isArray(categoriesData)) {
          setCategories(categoriesData);

          const topLevelCategories = Array.from(
            new Set(
              categoriesData.map(
                (item) => item.category_tree_name.split(" > ")[0],
              ),
            ),
          ).map((category) => ({ label: category, value: category }));

          setCategoryLevels([topLevelCategories]);
          setSelectedLevels([""]);
          setCategoryAvail(true);
        }
        
        // response of policy
        const ebayProfilesData = ebayProfilesResponse.data;


        let hasPaymentPolicies = false;
        let hasShippingPolicies = false;
        let hasReturnPolicies = false;
        // Process Payment Policies
        if (ebayProfilesData.payment_policies?.length) {
          setPaymentProfiles([
            { label: "Select Payment policy", value: "" },
            ...ebayProfilesData.payment_policies.map((policy) => ({
              label: policy.ProfileName,
              value: policy.ID.toString(),
              key: `payment-${policy.ID}`,
            })),
          ]);
          hasPaymentPolicies = true;
        }
        // Process Shipping Policies
        if (ebayProfilesData.shipping_policies?.length) {
           setShippingProfiles([
            { label: "Select Shipping policy", value: "" },
            ...ebayProfilesData.shipping_policies.map((policy) => ({
              label: policy.ProfileName,
              value: policy.ID.toString(),
              key: `shipping-${policy.ID}`,
            })),
          ]);
          hasShippingPolicies = true;
        }
        // Process Return Policies
        if (ebayProfilesData.return_policies?.length) {
           setReturnProfiles([
            { label: "Select Return policy", value: "" },
            ...ebayProfilesData.return_policies.map((policy) => ({
              label: policy.ProfileName,
              value: policy.ID.toString(),
              key: `return-${policy.ID}`,
            })),
          ]);
          hasReturnPolicies = true;
        }
        setNoBusinessPolicies(
          !hasPaymentPolicies && !hasShippingPolicies && !hasReturnPolicies,
        );
        setEbayProfile(true);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  const fetchItemCondition = async (categoryId) => {

    setShowSkelton(true);
    setTimeout(() => {
      window.scrollTo(0, 500);
    }, 1000); 

 
    try {
      const response = await Axios.get("profile/fetchItemCondition", {
        params: {
          category_id: categoryId,
        },
      });
    setSaveButtonDisable(false);
    setShowSkelton(false);


      if (response && response.data.condition) {

        const freshCondition = response.data.condition;

        if (response.data.is_variantions === false) {
          setIsVariantions(0);
          setVariationSupported(false);
        }

        // handle recommended

        if (Object.keys(response.data.recommended).length > 0) {
          setRecommendedCheck(true);
          setRecommended(response.data.recommended);
          const defaultMethod = {};
          const defaultValue = {};
          Object.entries(response.data.recommended).forEach(([key, values]) => {
            defaultMethod[key] = "recommenedValue";
            defaultValue[key] = values[0]; // First recommended value
          });
          setSelectedMethod(defaultMethod);
          setSelectedValue(defaultValue);
        } else {
          setRecommendedCheck(false);
        }
        //  handle product type here
        if (response.data.productTypeEnable === true) {
          setProductTypeCheck(true);
        } else {
          setProductTypeCheck(false);
        }
        if (response.data.productType === 'ALL') {
          setProductType1("UPC");
        }else{
          setProductType1(response.data.productType);
             setProductTypeHeadOptions([
                { label: response.data.productType, value: response.data.productType }
            ]);
        }
        if (response.data.ebay_category_id) {
          setEbayCategory(response.data.ebay_category_id);
        }
        if (freshCondition.length > 0) {
          setItemCondition(freshCondition); // updates state (async)
          const conditionOptions1 = freshCondition.map((cond) => ({
            label: cond.DisplayName,
            value: cond.ID,
          }));
          setConditionOptions(conditionOptions1);
          setSelectedCondition(conditionOptions1[0]);
        }
        setProductType(productTypeOptions[0].value);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCategoryChange = (levelIndex, selectedValue) => {
    setProductTypeCheck(false);
    setVariationSupported(true);
    setItemCondition(); // updates state (async)
    setRecommendedCheck(false);
    // Step 1: Update selected levels
    const newSelectedLevels = [...selectedLevels];
    newSelectedLevels[levelIndex] = selectedValue;
    newSelectedLevels.length = levelIndex + 1;
    setSelectedLevels(newSelectedLevels);

    // Step 2: Get next-level category options based on selected path
    const newOptions = categories
      .map((cat) => cat.category_tree_name.split(" > "))
      .filter((path) =>
        path
          .slice(0, levelIndex + 1)
          .every((cat, idx) => cat === newSelectedLevels[idx]),
      )
      .map((path) => path[levelIndex + 1])
      .filter(
        (value, index, self) =>
          self.indexOf(value) === index && value !== undefined,
      );

    const newCategoryLevels = [...categoryLevels];
    // ✅ Only add next level dropdown if options exist
    if (newOptions.length > 0) {
      newCategoryLevels[levelIndex + 1] = newOptions.map((category) => ({
        label: category,
        value: category,
      }));
    } else {
      newCategoryLevels.splice(levelIndex + 1); // 🔥 Removes extra dropdowns
    }
    setCategoryLevels(newCategoryLevels);

    // Step 3: Find and set the category ID
    const selectedPath = newSelectedLevels.join(" > ");
    const matchedCategory = categories.find(
      (cat) => cat.category_tree_name === selectedPath,
    );
    const categoryId = matchedCategory ? matchedCategory.id : null;
    setFinalCategoryId(categoryId);
    if (categoryId) {
      setEbayCategory1(categoryId);
      fetchItemCondition(categoryId);
    }
    // setTimeout(() => {
    //   window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    // }, 100); // Delay to ensure UI updates first

    // Step 4: If this is the last category, trigger API call
    // if (!newOptions.length && matchedCategory) {
    //     handleCategoryClick(matchedCategory, categoryId);
    // }
  };

  const validateForm = () => {
    let errors = {};
    let shouldScroll = false; // Flag to determine if we should scroll

    if (!profileName || profileName.trim() === "") {
      errors.profileName = "Profile Name is required";
      shouldScroll = true; // Mark scrolling needed
    }


    const profileData = userData.user.profileData;

    const match = profileData.find((item) => item.name === profileName);

    if (match) {
      errors.profileName =
        "Profile name already taken, Please enter a new name.";
      shouldScroll = true;
    }

    // Business policies validation
    const policies = [
      {
        key: "Shipping",
        profile: shippingProfiles,
        message: "Please add Shipping policy to your eBay account",
      },
      {
        key: "Payment",
        profile: paymentProfiles,
        message: "Please add Payment policy to your eBay account",
      },
      {
        key: "Return",
        profile: returnProfiles,
        message: "Please add Return policy to your eBay account",
      },
    ];

    policies.forEach(({ key, profile, message }) => {
      if (profile[0]?.label !== message && !selectedProfiles[key]) {
        errors[key] = `Please select a ${key} policy`;
        shouldScroll = true;
      }
    });

    if (multi_variation_check) {
      if (is_variantions === 0) {
        errors.category = "This category does not support variations.";
        shouldScroll = true; // Mark scrolling needed
      }
    }

    // Category validation (No scrolling for category errors)
    if (!finalCategoryId) {
      errors.category = "Please select all the category fields";
    }

    setErrors(errors);

    // Scroll to the top only if there are errors (excluding category)
    if (shouldScroll) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    const defaultMethod = {};
    const defaultValue = {};

    Object.entries(recommended).forEach(([key, values]) => {
      defaultMethod[key] = "recommenedValue";
      defaultValue[key] = values[0]; // First recommended value
    });

    setSelectedMethod(defaultMethod);
    setSelectedValue(defaultValue);
  }, []);

  const handleSave = async () => {
    if (!validateForm()) {
      return;
    }
    let toastId;
    if (sh_product_id.length > 0) {
      toastId = toast.loading("Import verification in progress...");
    }
    setSaveButtonDisable(true);
    const mappedData = getFinalMappedValues();


    const productDateToSave = {
      name: profileName,
      businessPolicies: selectedProfiles,
      ebay_category_id: ebay_category,
      ebay_categoryid1: ebay_category1,
      item_condition: selectedCondition,
      item_condition_data: itemCondition,
      productType: { name: productType1, value: productType },
      is_variantions: is_variantions,
      item_specific: mappedData,
      category_attributes: recommended,
    };
    try {
      const response = await Axios.post("profile/createProfile", {
        productDateToSave,
        sh_product_id,
      });
      if (response.status === 200) {
        toast.dismiss(toastId);

        const savedData = localStorage.getItem("storeData");
        const localData = savedData ? JSON.parse(savedData) : null;
        if (localData && localData.user) {
          localData.user.profileData = response.data.profiles;
          localStorage.setItem("storeData", JSON.stringify(localData));
          if (sh_product_id.length > 0) {
            toast.success("Product is verified for import.");

            if (response?.data.verify?.errors) {
              const error = response?.data.verify?.errors;
              let errors = [];
              error.forEach((item) => {
                  errors.push(item);
              });
              setVerifyError(errors);
              setVerifyErrorEnable(true);
              navigate(`${process.env.REACT_APP_BASE_URL}/shopify_products`, {
                state: {
                  error: errors,
                  sh_product_id: sh_product_id,
                },
              });
            } else {
              navigate(`${domain}/shopify_products`);
              return;
            }
          } else {
            toast.success("Profile Created Successfully.");
            navigate(`${domain}/profile`);
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Layout>
      <Layout.Section>
        <Page fullWidth title="Add Profile">
          <div style={{ marginBottom: "30px" }}>
            {showBanner && (
              <div style={{ marginBottom: "20px" }}>
                <Banner
                  onDismiss={() => setShowBanner(false)}
                  style={{ marginBottom: 20 }}
                >
                  <p>Fill all the form fields to upload the product to eBay.</p>
                </Banner>
              </div>
            )}
            <FormLayout>
              <Card>
              <TextField
                label="Profile Name"
                value={profileName}
                onChange={(value) => {
                  setProfileName(value);
                  if (errors.profileName) {
                    setErrors(prevErrors => ({ ...prevErrors, profileName: "" }));
                  }
                }}
                error={errors.profileName}
              />
              </Card>

              <Card>
                <div style={{ marginBottom: "20px" }}>
                  <Text variant="headingSm" as="h6">
                    Business Policies*
                  </Text>
                </div>
                {isMobile ? (

                ebayProfile ? (
                  <>
                    <div >
                      {["Shipping", "Payment", "Return"].map(
                        (profile, index) => (
                          <div
                            key={index}
                          >
                            {/* Select Field with Fixed Width */}
                            <div >
                              <Select
                                label={`${profile} Profile`}
                                options={
                                  profile === "Shipping"
                                    ? shippingProfiles
                                    : profile === "Payment"
                                      ? paymentProfiles
                                      : returnProfiles
                                }
                                value={selectedProfiles[profile]}
                                onChange={(value) =>
                                  handleProfileChange(profile, value)
                                }
                                error={errors[profile]}
                              />
                            </div>

                            {/* Plus Button with Popover */}
                            <Popover
                              active={popoverActive === index}
                              activator={
                                <Button
                                  size="slim"
                                  onClick={() => togglePopover(index)}
                                >
                                  +
                                </Button>
                              }
                              onClose={() => setPopoverActive(null)}
                            >
                              <ActionList
                                items={[
                                  {
                                    content: "Create",
                                    onAction: () =>
                                      handleAction("Create", index),
                                  },
                                  {
                                    content: "Refresh",
                                    onAction: () =>
                                      handleAction("Refresh", index),
                                  },
                                ]}
                              />
                            </Popover>
                          </div>
                        ),
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <SkeletonBodyText lines={8} />
                  </>
                )
                ) : (
                            ebayProfile ? (
                  <>
                    <div style={{ display: "flex", gap: "16px" }}>
                      {["Shipping", "Payment", "Return"].map(
                        (profile, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "flex-end",
                              gap: "8px",
                            }}
                          >
                            {/* Select Field with Fixed Width */}
                            <div style={{ width: "290px" }}>
                            <Select
                              label={`${profile} Profile`}
                              options={
                                profile === "Shipping"
                                  ? shippingProfiles
                                  : profile === "Payment"
                                    ? paymentProfiles
                                    : returnProfiles
                              }
                              value={selectedProfiles[profile]}
                              onChange={(value) => {
                                handleProfileChange(profile, value);
                                if (errors[profile]) {
                                  setErrors(prevErrors => ({ ...prevErrors, [profile]: "" }));
                                }
                              }}
                              error={errors[profile]}
                            />

                            </div>

                            {/* Plus Button with Popover */}
                            <Popover
                              active={popoverActive === index}
                              activator={
                                <Button
                                  size="slim"
                                  onClick={() => togglePopover(index)}
                                >
                                  +
                                </Button>
                              }
                              onClose={() => setPopoverActive(null)}
                            >
                              <ActionList
                                items={[
                                  {
                                    content: "Create",
                                    onAction: () =>
                                      handleAction("Create", index),
                                  },
                                  {
                                    content: "Refresh",
                                    onAction: () =>
                                      handleAction("Refresh", index),
                                  },
                                ]}
                              />
                            </Popover>
                          </div>
                        ),
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <SkeletonBodyText lines={8} />
                  </>
                )
                )}

              </Card>

              {noBusinessPolicies && (
                <Card>
                  <Banner
                    title={
                      <>
                        Please update the default shipping, return, and payment
                        fields that were provided during the import of items
                        into your eBay store. <Link url="">Click Here</Link>
                      </>
                    }
                    tone="warning"
                  />
                </Card>
              )}

              <Card>
                {categoryAvail ? (
                  <>
                    <label>Select Category</label>
                    {categoryLevels.map((options, index) => {
                      const isLastSelect = index === categoryLevels.length - 1; // Check if this is the last select field

                      return (
                        <div key={index} style={{ marginBottom: "15px" }}>
                          {" "}
                          {/* Adds spacing */}
                          <Select
                            key={index}
                            value={selectedLevels[index] || ""}
                            onChange={(value) =>
                              handleCategoryChange(index, value)
                            }
                            options={[
                              { label: "Select Category", value: "" },
                              ...options,
                            ]}
                            error={isLastSelect ? errors.category : null} // Show error only on the last select
                          />
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <SkeletonBodyText lines={4} />
                )}
                {!variationSupported && (
                  <Banner
                    title="This Category is Variation Not Supported"
                    tone="critical"
                  >
                    <p>
                      The selected eBay category does not support product
                      variations such as size or color options. If you want to
                      import a multi-variant product, please choose a different
                      category.
                    </p>
                  </Banner>
                )}
              </Card>
              <>
                {showSkelton && (
                  <Card>
                      <LegacyCard subdued>
                              <LegacyCard.Section>
                                <SkeletonBodyText lines={2} />
                              </LegacyCard.Section>
                              <LegacyCard.Section>
                                <SkeletonBodyText lines={2} />
                              </LegacyCard.Section>
                            </LegacyCard>
                               <LegacyCard subdued>
                              <LegacyCard.Section>
                                <SkeletonBodyText lines={2} />
                              </LegacyCard.Section>
                              <LegacyCard.Section>
                                <SkeletonBodyText lines={2} />
                              </LegacyCard.Section>
                            </LegacyCard>
                  </Card>
                )}
                {itemCondition && (
                  <div style={{ marginBottom: "20px" }}>
                    <Card>
                   
                      <Select
                        label="Select Condition*"
                        options={conditionOptions}
                        onChange={handleChangeCondition}
                        value={selectedCondition?.value || ''}
                      />
                    </Card>
                  </div>
                )}
                {productTypeCheck && (
                 <div style={{ marginBottom: "20px" }}>
                    <Card>
                        <div style={{ marginBottom: "20px" }}>
                        <Text variant="headingSm" as="h6">
                            Product Listing Details*
                        </Text>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                        <Select label="Product Type"
                        options={productTypeHeadOptions}
                        onChange={(value) => setProductType1(value)}
                        value={productType1}
                        />
                        <Select
                            options={productTypeOptions}
                            onChange={(value) => setProductType(value)}
                            value={productType}
                        />
                        </div>
                    </Card>
                </div>

                )}
                {recommendedCheck && (
                  <div style={{ marginBottom: "20px" }}>
                    <Card>
                      <div style={{ marginBottom: "20px" }}>
                        <Text variant="headingSm" as="h6">
                          Recommended Attribute Mapping*
                        </Text>
                      </div>

                      <LegacyStack vertical spacing="loose">
                        {Object.entries(recommended).map(([key, values]) => (
                          <div key={key} style={{ marginBottom: "30px" }}>
                            <Select
                              label={key}
                              options={recommendedOptions}
                              onChange={(value) =>
                                handleMethodChange(key, value)
                              }
                              value={selectedMethod[key] || ""}
                            />
                            {selectedMethod[key] === "recommenedValue" && values.length > 0  && (
                              <div style={{ marginTop: "10px" }}>
                                <Select
                                  options={values.map((val) => ({
                                    label: val,
                                    value: val,
                                  }))}
                                  onChange={(value) =>
                                    handleValueChange(key, value)
                                  }
                                  value={selectedValue[key] || ""}
                                />
                              </div>
                            )}

                            {selectedMethod[key] === "customValue"     && (
                              <div style={{ marginTop: "10px" }}>
                                <TextField
                                  placeholder="Enter Custom Value"
                                  value={selectedValue[key] || ""}
                                  onChange={(value) =>
                                    handleValueChange(key, value)
                                  }
                                />
                              </div>
                            )}
                            {(selectedMethod[key] === "shopifyValue" || values.length === 0)  && (
                              <div style={{ marginTop: "10px" }}>
                                <Select
                                  options={shopifyAttributeOptions}
                                  onChange={(value) =>
                                    handleValueChange(key, value)
                                  }
                                  value={selectedValue[key] || ""}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                      </LegacyStack>
                    </Card>
                  </div>
                )}
              </>
              <div   style={{width:'300px',margin:'auto'}}>
                <Button
                  disabled={saveButtonDisable}
                  submit
                  size="large"
                  fullWidth={true}
                  variant="primary"
                  onClick={handleSave}
                >
                  {sh_product_id.length > 0 ? "Save And Import" : "Save"}
                </Button>
              </div>
            </FormLayout>
          </div>
        </Page>
      </Layout.Section>
    </Layout>
  );
}
